import axios from 'axios';

export const loadSearches = () => {
  document.querySelectorAll('.search').forEach((div) => {
    new Search(div);
  });
};

class Search {
  constructor(div) {
    this.currentSearch = '';
    this.category = div.dataset.searchCategory;

    this.elements = {};
    this.elements.div = div;
    this.elements.input = div.querySelector('input');
    this.addResultsDiv();
    this.elements.input.addEventListener('input', this.onInputChange);
    this.elements.div.addEventListener('mousedown', this.onClick);
  }

  addResultsDiv = () => {
    this.elements.div.insertAdjacentHTML('beforeend', `<ul class="search__results"></ul>`);
    this.elements.results = this.elements.div.lastChild;
    this.addDefaultMessage();
  };

  addSearchResult = (title, tagline, link = '#') => {
    let tag = `<li class="search__result"><a class="search__result-link" href="${link}">`;
    if (title) tag += `<span class="search__result-title">${title}</span>`;
    if (tagline) tag += `<span class="search__result-tagline">${tagline}</span>`;
    tag += `</a></li>`;
    this.elements.results.insertAdjacentHTML('beforeend', tag);
  };

  clearSearchResults = () => {
    this.elements.results.innerHTML = '';
  };

  onInputChange = async (e) => {
    const input = e.target;
    const newValue = input.value;
    this.currentSearch = newValue;
    setTimeout(async () => {
      if (this.currentSearch !== newValue) return;
      await this.updateSearchResults();
    }, 400);
  };

  onClick = (e) => {
    const target = e.target;
    const a = target.closest('a');
    if (!a) return;
    e.preventDefault();
  };

  addDefaultMessage = () => {
    this.addSearchResult('Start typing to search...');
  };

  updateSearchResults = async () => {
    if (!this.currentSearch.length) {
      this.clearSearchResults();
      this.addDefaultMessage();
      return;
    }

    const config = {
      params: {
        term: this.currentSearch,
      },
    };

    if (this.category) {
      config.params['category.slug'] = this.category;
    }

    const { data } = await axios.get('__STRAPI_URL__/articles/search', config);

    if (!data || !data.length) {
      this.clearSearchResults();
      this.addSearchResult('No results');
      return;
    }

    this.clearSearchResults();
    data.forEach((result, i) => {
      if (i > 4) return;
      this.addSearchResult(result.title, result.subtitle, `/${result.slug}`);
    });
  };
}
